import { Outlet } from 'react-router-dom'
import { AppShell, type NavGroup } from './AppShell'

// Org admins manage their feed (uploaded audio + selected sources), members,
// and branding. Creator-only analytics/payouts are absent. Routes are namespaced
// under /org/* so they never collide with the creator portal the same app hosts.
export const ORG_NAV_GROUPS = [
  {
    groupKey: 'shell.groupManage',
    items: [
      { to: '/org/audio', labelKey: 'shell.navContent' },
      { to: '/org/ai-template', labelKey: 'shell.navAiTemplate' },
      { to: '/org/email-podcast', labelKey: 'shell.navEmailPodcast' },
      { to: '/org/daily-digest', labelKey: 'shell.navDailyDigest' },
      { to: '/org/members', labelKey: 'shell.navMembers' },
      { to: '/org/domains', labelKey: 'shell.navDomains' },
      { to: '/org/invite-codes', labelKey: 'shell.navInviteCodes' },
      { to: '/org/audience-groups', labelKey: 'shell.navAudienceGroups' },
      { to: '/org/feed-sources', labelKey: 'shell.navFeedSources' },
      { to: '/org/keywords', labelKey: 'shell.navKeywords' },
    ],
  },
  {
    groupKey: 'shell.groupAccount',
    items: [{ to: '/org/profile', labelKey: 'shell.navProfile' }],
  },
] as const satisfies readonly NavGroup[]

export function OrgAppShellLayout() {
  return (
    <AppShell navGroups={ORG_NAV_GROUPS}>
      <Outlet />
    </AppShell>
  )
}
